module.exports = __webpack_public_path__ + "media/images/font/Gustavo-LightItalic-bc74d01215ef94616ac752a1b309bd2d.ttf";